import { Select2Helper } from "../../Helpers/Select2Helper";

export class AddOrUpdateTaskPopupManager {

    constructor(private containerElement: JQuery) { }

    
    private dueDateInput : JQuery<HTMLElement>;
    private clearDueDateInputButton : JQuery<HTMLElement>;

    private linkSelectContainer : JQuery<HTMLElement>;
    private linkTypeSelect : JQuery<HTMLElement>;

    private customerSelectContainer : JQuery<HTMLElement>;
    private customerSelect : JQuery<HTMLElement>;

    private vesselSelectContainer : JQuery<HTMLElement>;
    private vesselSelect : JQuery<HTMLElement>;

    private projectSelectContainer : JQuery<HTMLElement>;
    private projectSelect : JQuery<HTMLElement>;

    public initialize() {
        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        self.dueDateInput = self.containerElement.find('#due-date-input');
        self.clearDueDateInputButton = self.containerElement.find('#clear-due-date-input-button');

        self.linkSelectContainer = self.containerElement.find('#link-select-container');
        self.linkTypeSelect = self.containerElement.find('#link-type-select');

        self.projectSelect = self.containerElement.find('#doc-header-select-list');
        self.projectSelectContainer = self.projectSelect.parent();

        self.customerSelect = self.containerElement.find('#erp-customer-select-list');
        self.customerSelectContainer = self.customerSelect.parent();

        self.vesselSelect = self.containerElement.find('#erp-vessel-select-list');
        self.vesselSelectContainer = self.vesselSelect.parent();
        

        self.containerElement.find('select.select2').each((index, element) => {
            var selectElement = $(element);
            Select2Helper.BindSelect2Input(selectElement);
        });
    }

    private bindEvents() {
        var self = this;

        var form =  this.containerElement.find('form');
        var submitButton = form.find(':submit');

        submitButton.off('click').on('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            submitButton.prop('disabled', true);
            form.trigger('submit');
        }) 

        self.clearDueDateInputButton.off('click').on('click', () => {
            self.dueDateInput.val('');
        })

        self.linkTypeSelect.off('change').on('change', () => {
            var selectedLinkType = self.linkTypeSelect.val();

            self.projectSelectContainer.addClass('d-none');
            self.customerSelectContainer.addClass('d-none');
            self.vesselSelectContainer.addClass('d-none');

            self.projectSelect.val('');
            self.customerSelect.val('');
            self.vesselSelect.val('');

            switch(selectedLinkType) {
                case 'None':
                    self.linkSelectContainer.addClass('d-none');
                    break;
                case 'Project':
                    self.linkSelectContainer.removeClass('d-none');
                    self.projectSelectContainer.removeClass('d-none');
                    break;
                case 'Customer':
                    self.linkSelectContainer.removeClass('d-none');
                    self.customerSelectContainer.removeClass('d-none');
                    break;
                case 'Vessel':
                    self.linkSelectContainer.removeClass('d-none');
                    self.vesselSelectContainer.removeClass('d-none');
                    break;
            }
        }) 
    }
}